import Links from './components/Links';
import Social from './components/Social';

export default function Footer() {
  return (
    <footer className="m-footer">
      <div className="container">
        <Links />
        <Social />
      </div>
    </footer>
  );
}
